"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const environments = [{
  name: "Government Agencies",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706817/img/government_stakeholder_meeting.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706817/img/government_stakeholder_meeting.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706817/img/government_stakeholder_meeting.png-wvc-sizes",
  alt: "Strategic planning session with government stakeholders",
  specs: [{
    label: "Scope",
    value: "Policy Alignment"
  }, {
    label: "Timeline",
    value: "Multi-year"
  }, {
    label: "Impact",
    value: "Public Infrastructure"
  }]
}, {
  name: "Private Developers",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706817/img/developer_coordination_workshop.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706817/img/developer_coordination_workshop.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706817/img/developer_coordination_workshop.png-wvc-sizes",
  alt: "Private sector project coordination meeting",
  specs: [{
    label: "Scope",
    value: "Asset Optimization"
  }, {
    label: "Timeline",
    value: "Quarterly"
  }, {
    label: "Impact",
    value: "Capital Efficiency"
  }]
}, {
  name: "Community Groups",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706817/img/community_engagement_session.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706817/img/community_engagement_session.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1706817/img/community_engagement_session.png-wvc-sizes",
  alt: "Community engagement workshop for local development",
  specs: [{
    label: "Scope",
    value: "Public Consensus"
  }, {
    label: "Timeline",
    value: "Ongoing"
  }, {
    label: "Impact",
    value: "Social License"
  }]
}];
export default function Stakeholder() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return;
}